import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListRowItemBaseLink } from '../list-row-item-base-link';

@Component({
    selector: 'fi-items-list-row-item-icon-a',
    templateUrl: './icon-a.component.html',
    styleUrls: ['./icon-a.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemIconAComponent extends ItemsListRowItemBaseLink {}
